export const INVENTORIES_QUERY_KEYS = {
  INVENTORIES: 'inventories',
  BOUNDARIES: 'boundaries',
  DETAIL: 'inventoryDetail',
  TARGET: 'inventoryTarget',
  CREATE: 'inventoryCreate',
  INVENTORY_REPORT: 'inventoryReport',
}
